export const SET_GIFT_CARD_DATA = 'ViewFabricGreetingCard/*/SetGiftCardData';
export const UPDATE_GIFT_CARD_DATA = 'ViewFabricGreetingCard/*/UpdateGiftCardData';
